import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { IonContent, IonDatetime, NavController, Platform } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { CallError, Media } from 'libs/vaelsys-webrtc-lib';
import * as moment from 'moment';
import { Camera } from 'src/app/models/Camera';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { VaelsysComponent } from '../vaelsys/vaelsys.component';
import { TranslateConfigService } from '../../../../services/commons/translate-config.service';
import { ModalService } from '../../../../services/commons/modal.service';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { VideoCellType } from 'libs/ngx-video-timeline';
import { Subscription } from 'rxjs';
import { VaelsysWebrtcService } from 'src/app/services/vaelsys/vaelsys-webrtc.service';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';


@Component({
  selector: 'app-recordings',
  templateUrl: './recordings.component.html',
  styleUrls: ['./recordings.component.scss'],
})
export class RecordingsComponent implements OnInit {

  isModalOpen: Boolean = false;
  isServiceBusy = false;
  @ViewChild(IonDatetime) ionDateSince: IonDatetime;
  @ViewChild(IonDatetime) ionDateUntil: IonDatetime;
  @ViewChild(IonDatetime) ionHourSince: IonDatetime;
  @ViewChild(IonDatetime) ionHourUntil: IonDatetime;
  today: Date = new Date();
  dateSinceAux = '';
  dateUntilAux = '';
  dateSinceFormatted = '';
  dateUntilFormatted = '';
  hourSinceFormatted = '';
  hourUntilFormatted = '';
  isDateSinceValid = true;
  isDateUntilValid = true;
  @ViewChild(VaelsysComponent) vaelsys: VaelsysComponent;
  @Input('camera') camera: Camera = new Camera();
  @Input('user') user: string;
  deviceId: string;
  validationCode: string;
  connectedToDevice: boolean;
  connectionStateString: string = '';
  connectionState$: Subscription;
  recordings: Media[] = [];
  mediaLookup: Media[] = [];
  textToday = 'HOY';
  callIsPlayback: boolean;
  speed: number;
  canvasHeight: number;
  startTimeThreshold: number | string | Date;
  endTimeThreshold: number | string | Date;
  videoCells: any;
  playTime: number;
  isPlayClick: boolean;
  isRecording: boolean;
  currentRecording: number;
  isTimeline: boolean;
  @ViewChildren('items_recording') inputsArray: QueryList<ElementRef>;
  scrollDepthTriggered: boolean;
  limitPag = 0;
  @ViewChild('scrollableList') scrollableList: IonContent;
  recordingSelected: any;
  isViewPlaying: boolean;
  isRecordingLoading: boolean;
  @ViewChild('pinchElement', { static: false }) pinchElement;
  portrait: boolean;
  web: boolean;
  zoomState = 1;
  orientation: string;
  private topOverlayElement: HTMLDivElement; // test only
  private timeoutDelay: any; // test only
  isLoadingRecordsFinished: boolean;
  hoursToLoad = [
    { start: 22, end: 23 },
    { start: 20, end: 21 },
    { start: 18, end: 19 },
    { start: 16, end: 17 },
    { start: 14, end: 15 },
    { start: 12, end: 13 },
    { start: 10, end: 11 },
    { start: 8, end: 9 },
    { start: 0, end: 7 },
    /* { start: 14, end: 14 },
    { start: 13, end: 13 },
    { start: 12, end: 12 },
    { start: 11, end: 11 },
    { start: 10, end: 10 },
    { start: 9, end: 9 },
    { start: 8, end: 8 },
    { start: 7, end: 7 },
    { start: 6, end: 6 },
    { start: 0, end: 5 }, */
  ]

  constructor(
    public platform: Platform,
    public gms: GlobalMethodsService,
    private translate: TranslateConfigService,
    private modalService: ModalService,
    private gvs: GlobalVariablesService,
    private vaelsysWebrtcService: VaelsysWebrtcService,
    private screenOrientation: ScreenOrientation,
    public navCtrl: NavController // test only
  ) {
      this.platform.ready().then(async () => {
        let dateSince = new Date(Date.UTC(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 0, 0, 0, 0));
        this.dateSinceAux = dateSince.toISOString();
        let dateUntil = new Date(Date.UTC(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 23, 59, 59));
        this.dateUntilAux = dateUntil.toISOString();
        this.speed = 1000;
        this.isPlayClick = false;
        this.canvasHeight = 140;
        this.startTimeThreshold = new Date(Date.UTC(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 0, 0, 0, 0));
        this.endTimeThreshold = new Date(Date.UTC(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 23, 59, 59));
        this.videoCells = [];
        this.playTime = new Date().getTime();
        this.recordingSelected = {};
        this.isViewPlaying = false;
        this.isRecordingLoading = false;
      });
    }

  async ngOnInit() {
    this.gms.setLoadingTrue('Obteniendo grabaciones ...');
    if (this.platform.is('desktop')) {
      this.web = true;
    } else {
      this.web = false;
    }
  }

  async ngAfterViewInit() {
    this.subscribeConnectionState();
    this.topOverlayElement = document.getElementById('topOverlay') as HTMLDivElement; // hidde/ show overlay by play-pause button
    this.resetIdleTimer(); // hidde/ show overlay by play-pause button
  }

  ngOnDestroy() {
    if (this.connectionState$ != null) {
      this.connectionState$.unsubscribe();
    }
  }

  onPlay(): void {
    this.isViewPlaying = true;
    this.isPlayClick = true;
    this.isRecordingLoading = false;
    this.startTimeThreshold = new Date().getTime() - 1 * 3600 * 1000;
  }

  onPause(): void {
    this.isPlayClick = false;
  }

  async changeRecording(date: number): Promise<void> {
    console.log('changeRecording');
    if (date != null) {
      let newDate = new Date(date);
      newDate.setTime(new Date(date).getTime() + 3600000);
      await this.seek(this.gms.getUTCDate(newDate));
    } else {
      this.onPause();
    }
  }

  subscribeConnectionState() {
    this.connectionState$ = this.vaelsysWebrtcService.subscribeConnectionState().subscribe({
      next: async (value) => {
        console.log('subscribeConection', value)
        console.log(this.connectionStateString)
        if (this.connectionStateString === 'connecting' && value === 'connected') {
          await this.connect();
        }
        this.connectionStateString = value;
        if (this.connectionStateString === 'new') {
          if (this.user == null) {
            this.user = this.gvs.user.userName;
          }
          this.vaelsysWebrtcService.updateStatusService$.next({ status: true, user: this.user })
        }

        if (value === 'connected') {
          this.connectedToDevice = true;
        }
        if (value === 'failed') {
          this.connectedToDevice = false;
          this.callIsPlayback = false;
          if (this.connectionState$ != null) {
            this.connectionState$.unsubscribe();
          }
          this.onPause();
          await this.lastError();
        }
        if (value === 'streamdisconnected' || value === 'disconnected') {
          this.connectedToDevice = false;
          this.callIsPlayback = false;
          this.onPause();
        }
        if (value === 'streaming') {
          this.onPlay();
          if (this.gms.showLoading) {
            this.gms.setLoadingFalse();
          }
        }

        if (value === 'closed') {
          this.isViewPlaying = false;
          this.connectedToDevice = false;
          this.callIsPlayback = false;
          this.onPause();
        }
      },
      error: async (error) => {
        if (this.gms.showLoading) {
          this.gms.setLoadingFalse();
        }
        await this.lastError();
      }
    });
  }

  async connect() {
    console.log('connect')
    let result = await this.vaelsys.connect();
    if (!result) {
      this.gms.setLoadingFalse();
      if (this.connectionStateString === 'connected') {
        this.lastError();
      }
    } else {
      this.connectedToDevice = true;
      this.lookup();
    }
  }

  async disconnect() {
    this.gms.setLoadingTrue();
    this.connectedToDevice = false;
    this.gms.setLoadingFalse();
    // setTimeout(() => { this.dismiss() }, 100);
    this.callIsPlayback = false;
    this.isViewPlaying = false;
    this.dismiss()
    console.log('disconnect')
  }

  /* async lookup(value?) {
    console.log('lookup')
    if (!this.gms.showLoading) {
      this.gms.setLoadingTrue();
    }
    if (value != null) {
      this.limitPag = 0;
      this.pause();
      this.dateChange(value);
      const tempNewDate = new Date(value);
      this.startTimeThreshold = new Date(tempNewDate.getFullYear(), tempNewDate.getMonth(), tempNewDate.getDate(), 0, 0, 0, 0);
      this.endTimeThreshold = new Date(tempNewDate.getFullYear(), tempNewDate.getMonth(), tempNewDate.getDate(), 23, 59, 59);
      this.playTime = new Date(tempNewDate.getFullYear(), tempNewDate.getMonth(), tempNewDate.getDate(), this.today.getUTCHours(), this.today.getMinutes(), this.today.getSeconds(), 0).getTime();
    }
    const tempStartDate = new Date(this.dateSinceAux);
    let startDate = new Date(tempStartDate.getFullYear(), tempStartDate.getMonth(), tempStartDate.getDate(), tempStartDate.getHours(), tempStartDate.getMinutes(), tempStartDate.getSeconds()).toISOString();
    const tempEndDate = new Date(this.dateUntilAux);
    let endDate = new Date(tempEndDate.getFullYear(), tempEndDate.getMonth(), tempEndDate.getDate(), tempEndDate.getHours(), tempEndDate.getMinutes(), tempEndDate.getSeconds()).toISOString();
    console.log(new Date(this.startTimeThreshold).toISOString(), new Date(this.endTimeThreshold).toISOString());
    await this.getMediaLookup(new Date(this.startTimeThreshold).toISOString(), new Date(this.endTimeThreshold).toISOString(), false);

    
    this.gms.setLoadingFalse();
    if (value != null) {
      this.setModal();
    }
  } */

  lookup(value?) {
    this.isRecordingLoading = false;
    if (!this.gms.showLoading) {
      this.gms.setLoadingTrue('Obteniendo grabaciones ...');
    }
    this.hoursToLoad = [];
    this.isLoadingRecordsFinished = false;
    const hoursToLoad = [
      { start: 22, end: 23 },
      { start: 20, end: 21 },
      { start: 18, end: 19 },
      { start: 16, end: 17 },
      { start: 14, end: 15 },
      { start: 12, end: 13 },
      { start: 10, end: 11 },
      { start: 8, end: 9 },
      { start: 0, end: 7 },
      /* { start: 14, end: 14 },
      { start: 13, end: 13 },
      { start: 12, end: 12 },
      { start: 11, end: 11 },
      { start: 10, end: 10 },
      { start: 9, end: 9 },
      { start: 8, end: 8 },
      { start: 7, end: 7 },

      { start: 6, end: 6 },
      { start: 0, end: 5 }, */
    ]
    this.recordings = [];
    this.mediaLookup = [];
    if (value != null) {
      this.limitPag = 0;
      this.pause();
      this.dateChange(value);
      this.hoursToLoad = hoursToLoad;
      const tempNewDate = new Date(value);
      this.playTime = new Date(tempNewDate.getFullYear(), tempNewDate.getMonth(), tempNewDate.getDate(), this.today.getUTCHours(), this.today.getMinutes(), this.today.getSeconds(), 0).getTime();
      this.getRecordings(tempNewDate);
    } else {
      const today = new Date()
      const nowHour = today.getHours()
      const indexHour = hoursToLoad.findIndex(item => item.start === nowHour || item.end === nowHour);
      this.hoursToLoad = hoursToLoad.slice(indexHour);
      this.getRecordings(today);
    }
    if (value != null) {
      this.setModal();
    }
  }

  getRecordings(dateSelected) {
    const dateToLoad = this.hoursToLoad.shift();
    console.log('dateToLoad', dateToLoad)
    const startDate = new Date(Date.UTC(dateSelected.getFullYear(), dateSelected.getMonth(), dateSelected.getDate(), dateToLoad.start, 0, 0, 0)).toISOString();
    const endDate = new Date(Date.UTC(dateSelected.getFullYear(), dateSelected.getMonth(), dateSelected.getDate(), dateToLoad.end, 59, 59)).toISOString();
    this.vaelsys.mediaLookup(startDate, endDate).then((result) => {
      if (result?.length !== 0 || this.hoursToLoad.length === 0) {
        const revertOrder = result.reverse()
        this.recordings = this.recordings.concat(revertOrder);
        if (this.recordings.length >= 10 || this.hoursToLoad.length === 0) {
          this.mediaLookup = this.recordings;
          this.gms.setLoadingFalse()
        }
      }
      if (this.hoursToLoad.length > 0) {
        this.getRecordings(dateSelected)
      } else {
        this.gms.setLoadingFalse();
      }
    })
  }

  /* async getMediaLookup(startDate: string, endDate: string, pagination: boolean) {
    console.log(startDate + ' - ' + endDate);
    // const getRecordings = await this.vaelsys.mediaLookup(startDate, endDate);
    // console.log(getRecordings)
    if (!pagination) {
      this.mediaLookup = [];
      this.mediaLookup = getRecordings.reverse()
    }
    this.limitPag = this.limitPag + this.recordings.length;
    if (this.limitPag >= 10) {
      this.gms.setLoadingFalse();
    }
    if (pagination) {
      this.recordings = this.recordings.concat(await this.vaelsys.mediaLookup(startDate, endDate));
      if (this.recordings.length >= 10 || this.isLoadingRecordsFinished) {
        this.mediaLookup = this.recordings;
        this.gms.setLoadingFalse();
      }
    }
    if (!pagination) {
      this.scrollableList.scrollToTop(0);
    }
    //this.mediaLookup = this.mediaLookup.reverse();
  } */

  async seek(startDate: Date, endDate?: Date, id?: number) {
    this.isViewPlaying = false;
    this.playTime = Number(startDate.getTime());
    this.isRecordingLoading = true;
    this.isRecording = true;
    const recordingIndex = this.mediaLookup.findIndex(value => this.gms.getUTCDate(value.start).getTime() === startDate.getTime());
    const recording = this.mediaLookup[recordingIndex]
    if (recording != null) {
      startDate = recording.start;
      endDate = recording.end;
      this.recordingSelected = { 
        id: recording.id,
        index: recordingIndex
      }
    }
    let result = this.vaelsys.seek(startDate, endDate)
    if (result) {
      this.callIsPlayback = true;
      this.onPause();
    } else {
      await this.lastError();
    }
  }

  async previousNext(action) {
    // this.isViewPlaying = false;
    let index = this.recordingSelected.index;
    if (action === 'next') {
      index++;
    } else {
      index--;
    }
    if (index >= 0 && index < this.mediaLookup.length) {
      let recording = this.mediaLookup[index];
      this.recordingSelected = { 
        id: recording.id,
        index: index
      }
      await this.seek(this.gms.getUTCDate(recording.start), this.gms.getUTCDate(recording.end), recording.id);
    }
  }

  async lastError() {
    let error: CallError | undefined = this.vaelsys.lastError();
    if (error) {
      const modal = await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.videoStreamingKo'),
        'KO', await this.translate.getTranslate('BUTTON.accept'));
      modal.onDidDismiss().then(async response => {
        await this.disconnect();
      });
    }
  }

  returnZero() {
    return 0;
  }

  dateChange(value) {
    let date = new Date(value);
    this.dateSinceAux = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)).toISOString();
    this.dateUntilAux = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)).toISOString();
  }

  isToday() {
    moment.locale(this.gvs.lang);
    if (moment().format('YYYY-MM-DD') === moment(this.playTime).format('YYYY-MM-DD')) {
      return 'HOY';
    } else {
      return moment(this.playTime).format('DD/MM/YY');
    };
  }

  isNow(key: string) {
    moment.locale(this.gvs.lang);
    let today = moment().format('YYYY-MM-DD');
    let timestamp = moment(today, 'YYYY-MM-DD').valueOf();
    return moment(key, 'DD MMM YYYY').valueOf() === timestamp ? true : false;
  }

  setModal(): void {
    this.callIsPlayback = false;
    this.isModalOpen = !this.isModalOpen;
  }

  duration(value: Media) {
    const duration = moment.duration(moment(value.end.toISOString()).diff(moment(value.start.toISOString())));
    if (duration.asMinutes() < 1) {
      return duration.asSeconds() < 10 ? '0:' + '0' + duration.asSeconds() : '0:' + duration.asSeconds();
    } else {
      let diffMin = duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes();
      let diffSeconds = duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds();
      return diffMin + ':' + diffSeconds;
    }
  }

  dismiss() {
    this.modalService.hide('recordingsModal');
  }

  willDismiss() {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'backdrop') {
      this.isModalOpen = false;
    }
  }

  changeView() {
    this.isTimeline = !this.isTimeline;
  }

  async play() {
    const isPaused = await this.vaelsys.isPaused();
    if (isPaused) {
      this.onPlay();
      await this.vaelsys.setPaused(false);
    }
  }

  async pause() {
    const isPaused = await this.vaelsys.isPaused();
    if (!isPaused) {
      this.onPause();
      await this.vaelsys.setPaused(true);
    }
  }

  async playPause() {
    if (this.isPlayClick) {
      await this.pause();
    } else {
      await this.play();
    }
    this.resetIdleTimer()
  }

  public toggleOverlayByUser() { // hidde/ show overlay by play-pause button
    console.log("into toggle overlay");
    this.topOverlayElement.classList.remove('fadeOut');
    this.resetIdleTimer();
    if (this.topOverlayElement.classList.contains('top-overlay-hidden')) {
      this.topOverlayElement.classList.remove('top-overlay-hidden');
      this.topOverlayElement.classList.add('fadeIn');
    }
    else {
      this.topOverlayElement.classList.remove('fadeIn');
      this.topOverlayElement.classList.add('top-overlay-hidden');
    }
  }

  public resetIdleTimer() // hidde/ show overlay by play-pause button
  {
    clearTimeout(this.timeoutDelay);
    this.timeoutDelay = setTimeout(() => {
      if (!this.topOverlayElement.classList.contains('top-overlay-hidden')) {
        this.topOverlayElement.classList.add('fadeOut', 'top-overlay-hidden');
        this.topOverlayElement.classList.remove('fadeIn');
      }
    }, 4000);
  }

  toggleZoom() {
    switch (this.zoomState) {
      case 1:
        this.zoomState = 2;
        this.pinchElement.setZoom({ scale: 2 });
        break;
      case 2:
        this.zoomState = 3;
        this.pinchElement.setZoom({ scale: 3 });
        break;
      case 3:
        this.zoomState = 1;
        this.pinchElement.reset();
        break;
    }
  }

  async logScrolling($event) {
    if (this.scrollDepthTriggered) {
      return;
    }
    const scrollElement = await $event.target.getScrollElement();
    const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    const currentScrollDepth = scrollElement.scrollTop;
    const targetPercent = 99.99;
    const triggerDepth = ((scrollHeight / 100) * targetPercent) - 2;

    if (currentScrollDepth > triggerDepth && this.limitPag < 1 && currentScrollDepth > 1) {
      this.gms.setLoadingTrue();
      this.scrollDepthTriggered = true;
      await this.pagination();
      this.limitPag++;
      this.scrollDepthTriggered = false;
      this.gms.setLoadingFalse();
    }
  }

  async pagination() {
    let date = new Date(this.dateSinceAux);
    let hourLimitStart = 13;
    let hourLimitEnd = 24;
    if (this.limitPag === 1) {
      hourLimitStart = 13;
      hourLimitEnd = 24;
    }
    let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hourLimitStart, 0, 0, 0).toUTCString();
    let endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hourLimitEnd, 59, 59).toUTCString();
    // await this.getMediaLookup(startDate, endDate, true);
  }
}
